import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { GET_USERS } from "../apiRoutes";

const getBomUserCommunities = async () =>
  await axiosAuth.get(`${GET_USERS}/communities/access`);

const useGetBomUserCommunities = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bom-user-communitites"],
    queryFn: () => getBomUserCommunities(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: queryParams?.enabled,
  });
};

export default useGetBomUserCommunities;
